import { t } from "i18next";
import React from "react";
import CustomImageComponent from "../../components/CustomImageComponent";
import { useCountryPrefix } from "../../routes/useCountryPrefix";
import { useTranslation } from "react-i18next";

const MapSec = (props) => {
  const { data, offerData } = props;
  const countryPrefix = useCountryPrefix();
  const { i18n } = useTranslation();
  const currentLang = i18n.language === "en" ? "" : i18n.language || "";
  return (
    <>
      {data && (
        <section
          className="map-section"
          data-aos="fade-up"
          data-aos-duration="1500"
        >
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-12 col-lg-7">
                <div className="map-card" style={{
                  backgroundImage: `url("${data?.sectionItems?.[0]?.image}")`,
                  backgroundRepeat: "no-repeat"
                }}>
                  <h5>{data?.sectionTitle || ""}</h5>
                  <h2>{data?.sectionHeader || ""}</h2>
                  <p>{data?.sectionDescription || ""}</p>
                  <a href={`/${countryPrefix}${currentLang ? `/${currentLang}` : ""}/map`} className="link-arrow">
                    <CustomImageComponent src={"/assets/img/link-arrow.svg"} alt={"link-arrow"} />
                  </a>
                </div>
              </div>

              <div className="col-md-12 col-lg-5">
                <div className="map-card home-offer-card" style={{
                  backgroundImage: `url("${offerData?.sectionItems?.[0]?.image}")`,
                  backgroundRepeat: "no-repeat"
                }}>
                  <h5>
                    {offerData?.sectionTitle}
                  </h5>
                  <h2>
                    {offerData?.sectionHeader}
                  </h2>
                  <p>
                    {offerData?.sectionDescription}
                  </p>
                  <a href={`/${countryPrefix}${currentLang ? `/${currentLang}` : ""}/offer`} className="link-arrow">
                    <CustomImageComponent src={"/assets/img/link-arrow.svg"} alt={"link-arrow"} />
                  </a>
                  <div className="offer-text">
                    <span>
                      {t("offer")}%
                    </span>
                    <CustomImageComponent src={"/assets/img/offer-text.svg"} className={"img-fluid"} alt={"offer-text"} />
                  </div>
                </div>
              </div>

            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default MapSec;
